import React from 'react';

const FocusContext = React.createContext({
  content: null,
  element: null,
  activeMenu: null,
  hasTabbedContent: true,
  contentAttributes: null,
  setElement: _ => _,
  setContent: _ => _,
  setActiveMenu: _ => _,
  setHasTabbedContent: _ => _,
  setContentAttributes: _ => _
});
const FocusContextConsumer = FocusContext.Consumer;
class FocusContextProvider extends React.Component {
  constructor(props) {
    super(props);

    this.setContent = content => {
      this.setState({
        content
      });
    };

    this.setElement = element => {
      this.setState({
        element
      });
    };

    this.setActiveMenu = activeMenu => {
      this.setState({
        activeMenu
      });
    };

    this.setHasTabbedContent = hasTabbedContent => {
      this.setState({
        hasTabbedContent
      });
    };

    this.setContentAttributes = contentAttributes => {
      this.setState({
        contentAttributes
      });
    };

    this.state = {
      content: null,
      element: null,
      activeMenu: null,
      hasTabbedContent: true,
      contentAttributes: null
    };
  }

  render() {
    return /*#__PURE__*/React.createElement(FocusContext.Provider, {
      value: { ...this.state,
        setElement: this.setElement,
        setContent: this.setContent,
        setActiveMenu: this.setActiveMenu,
        setHasTabbedContent: this.setHasTabbedContent,
        setContentAttributes: this.setContentAttributes
      }
    }, this.props.children);
  }

}
FocusContextProvider.contextType = FocusContext;

export default FocusContext;
export { FocusContextConsumer, FocusContextProvider };
//# sourceMappingURL=index.js.map
